var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReactNative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1540_259",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1540_259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0004 46.8933C43.8126 46.8933 46.9031 43.7777 46.9031 39.9344C46.9031 36.0912 43.8126 32.9756 40.0004 32.9756C36.1881 32.9756 33.0977 36.0912 33.0977 39.9344C33.0977 43.7777 36.1881 46.8933 40.0004 46.8933Z",
    fill: "#00D8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0006 25.7861C49.2685 25.7861 57.878 27.1268 64.3696 29.3798C72.1911 32.0944 77 36.2091 77 39.9349C77 43.8175 71.9035 48.1888 63.5043 50.9943C57.1543 53.1152 48.7982 54.2224 40.0006 54.2224C30.9807 54.2224 22.4394 53.1832 16.0178 50.971C7.89342 48.1714 3 43.7436 3 39.9349C3 36.2393 7.59154 32.1564 15.303 29.4459C21.8188 27.1558 30.641 25.7861 39.9994 25.7861H40.0006Z",
    stroke: "#00D8FF",
    strokeWidth: 2.73408
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7832 32.9011C32.4133 24.8075 37.8661 17.9584 43.0452 13.4147C49.2851 7.94019 55.2233 5.79623 58.4247 7.65735C61.7611 9.59698 62.9711 16.2318 61.1858 24.9683C59.8374 31.5735 56.613 39.4239 52.218 47.1069C47.7117 54.9842 42.5519 61.9243 37.4434 66.4258C30.9792 72.1225 24.7297 74.1841 21.457 72.2814C18.2813 70.4365 17.0669 64.3858 18.5903 56.297C19.8775 49.4626 23.1079 41.0739 27.7817 32.901L27.7832 32.9011Z",
    stroke: "#00D8FF",
    strokeWidth: 2.73408
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7947 47.1273C23.1516 39.0428 19.9903 30.858 18.6708 24.0654C17.0824 15.8813 18.2054 9.62398 21.404 7.75745C24.7371 5.81213 31.0432 8.06872 37.6594 13.9912C42.6618 18.4689 47.7985 25.2044 52.2064 32.8803C56.7255 40.7499 60.1126 48.7228 61.4302 55.4326C63.0974 63.9237 61.748 70.4115 58.4783 72.3196C55.3058 74.1711 49.5003 72.2108 43.3099 66.8404C38.0795 62.3031 32.4837 55.2921 27.7947 47.1271V47.1273Z",
    stroke: "#00D8FF",
    strokeWidth: 2.73408
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactNative);
export default __webpack_public_path__ + "static/media/React-native.c9e0456654bd92be474b24ba28767f55.svg";
export { ForwardRef as ReactComponent };